import { render, staticRenderFns } from "./NotFoundCard.vue?vue&type=template&id=2571d9c8&scoped=true"
import script from "./NotFoundCard.vue?vue&type=script&lang=js"
export * from "./NotFoundCard.vue?vue&type=script&lang=js"
import style0 from "./NotFoundCard.vue?vue&type=style&index=0&id=2571d9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2571d9c8",
  null
  
)

export default component.exports